
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Ebene_1","xmlns":"http://www.w3.org/2000/svg","version":"1.1","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"fill":"#009ee2","d":"M7.13 8.3H3.08c-.06 0-.12.03-.15.09L.08 13.61c-.06.11.02.25.15.25h2.39c.06 0 .12-.03.15-.09l1.43-2.6c.03-.05.09-.09.15-.09h1.46c.06 0 .12-.03.15-.09L7.3 8.55a.17.17 0 00-.15-.25z"}}),_c('path',{attrs:{"fill":"#009ee2","d":"M13.9 2.15h-2.39c-.06 0-.12.03-.15.09L9.96 4.8c-.04.08-.13.13-.22.13H4.93c-.06 0-.12.03-.15.09L3.44 7.46c-.06.11.02.25.15.25h4.56c.1 0 .16.1.11.19l-1.61 2.93c-.06.11.02.25.15.25h2.39c.06 0 .12-.03.15-.09l4.7-8.6a.17.17 0 00-.15-.25zM15.78 4.92h-2.39c-.06 0-.12.03-.15.09l-3.18 5.82c-.06.11.02.25.15.25h2.39c.06 0 .12-.03.15-.09l3.18-5.82a.17.17 0 00-.15-.25z"}})])
          )
        }
      }
    